import {
    GET_LIST_WORKSPACE,
    GET_LIST_APPS,
    GET_LIST_USER_CONNECT,
    GET_LIST_CONNECT_OF_MEMBER,
    CREATE_LIST_CONNECT,
    GET_ACCESS_TOKEN,
    GET_LIST_VIEWS,
    DELETE_USER_CONNECT,
    CHANGE_STATUS_USER_CONNECT,
    DETAIL_LIST_CONNECT,
    UPDATE_LIST_CONNECT,
    UPDATE_USER_CONNECT,
    GET_LIST_WORKSPACE_ALL,
    GET_USER_CONNECT_NOT_PERMISSION,
    GET_SHEET_OF_SPREADSHEETS,
    GET_ALL_FIELDS_FILTER,
    UPDATE_NOTES
} from '@/api/modules/connect.api';

export default {
    getListWorkspace({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_WORKSPACE({ payload }, successCallback, errorCallback);
    },
    get_list_user_connect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_USER_CONNECT({ payload }, successCallback, errorCallback);
    },

    getListConnectOfMember({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_CONNECT_OF_MEMBER({ payload }, successCallback, errorCallback);
    },

    getListApps({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_APPS({ payload }, successCallback, errorCallback);
    },

    getListViews({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_VIEWS({ payload }, successCallback, errorCallback);
    },

    createListConnect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE_LIST_CONNECT({ payload }, successCallback, errorCallback);
    },

    updateListConnect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_LIST_CONNECT({ payload }, successCallback, errorCallback);
    },

    updateNotes({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_NOTES({ payload }, successCallback, errorCallback);
    },

    getAccessToken({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_ACCESS_TOKEN({ payload }, successCallback, errorCallback);
    },

    getDetailConnect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DETAIL_LIST_CONNECT({ payload }, successCallback, errorCallback);
    },
    delete_user_connect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DELETE_USER_CONNECT({ payload }, successCallback, errorCallback);
    },
    change_status_user_connect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CHANGE_STATUS_USER_CONNECT({ payload }, successCallback, errorCallback);
    },
    update_user_connect({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_USER_CONNECT({ payload }, successCallback, errorCallback);
    },
    get_list_workspace_all({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_WORKSPACE_ALL({ payload }, successCallback, errorCallback);
    },
    get_user_connect_not_permission({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_USER_CONNECT_NOT_PERMISSION({ payload }, successCallback, errorCallback);
    },
    getSpreadSheets({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_SHEET_OF_SPREADSHEETS({ payload }, successCallback, errorCallback);
    },
    getAllFieldFilter({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_ALL_FIELDS_FILTER({ payload }, successCallback, errorCallback);
    }
};
